@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
                 11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Logging in...</p>
  </div>
}

@if (!isLoading) {
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card booking-card auth-card">
          <div
            class="card-header booking-card__header text-center justify-content-center flex-column pb-3"
          >
            <div class="booking-card__eyebrow">Medical Portal Access</div>
            <h2 class="sub-title mb-0 fs-3">Welcome Back</h2>
          </div>

          <div class="card-body p-4">
            <!-- Prominent In-Card Error Alert -->
            @if (errorMessage) {
              <div
                class="alert alert-danger d-flex align-items-start mb-4 p-3 rounded-3 shadow-sm border-danger border-start border-4"
                role="alert"
              >
                <i
                  class="bi bi-exclamation-octagon-fill fs-4 me-3 text-danger flex-shrink-0 mt-1"
                ></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-danger">Authentication Failed</div>
                  <div class="small text-dark mt-1">{{ errorMessage }}</div>
                </div>
                <button
                  type="button"
                  class="btn-close ms-2"
                  (click)="errorMessage = null"
                  aria-label="Close error message"
                ></button>
              </div>
            }

            <form [formGroup]="loginForm" (ngSubmit)="submitLogin()" novalidate>
              <!-- Email -->
              <div class="mb-3">
                <label for="email" class="form-label">Email Address</label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="name@practice.com"
                  autocomplete="email"
                />
                @if (
                  loginForm.controls['email'].touched &&
                  loginForm.controls['email'].errors?.['required']
                ) {
                  <div class="text-danger small mt-1">Email is required.</div>
                }
                @if (
                  loginForm.controls['email'].touched &&
                  loginForm.controls['email'].errors?.['email']
                ) {
                  <div class="text-danger small mt-1">Enter a valid email.</div>
                }
              </div>

              <!-- Password -->
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <div class="input-group">
                  <input
                    id="password"
                    [type]="hidePassword() ? 'password' : 'text'"
                    class="form-control"
                    formControlName="password"
                    placeholder="Enter your password"
                    autocomplete="current-password"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="toggle('password')"
                    [attr.aria-pressed]="!hidePassword()"
                  >
                    <i
                      class="bi"
                      [class.bi-eye]="hidePassword()"
                      [class.bi-eye-slash]="!hidePassword()"
                    ></i>
                  </button>
                </div>
                @if (
                  loginForm.controls['password'].touched && loginForm.controls['password'].invalid
                ) {
                  <div class="text-danger small mt-1">Password is required.</div>
                }
              </div>

              <!-- Forgot password -->
              <div class="d-flex justify-content-end align-items-center mb-4">
                <a
                  routerLink="/forgot-password"
                  class="small text-primary text-decoration-none fw-semibold"
                  >Forgot password?</a
                >
              </div>

              <!-- Submit -->
              <div class="d-grid">
                <button type="submit" class="btn btn-primary py-2" [disabled]="loginForm.invalid">
                  <i class="bi bi-box-arrow-in-right me-1"></i> Sign In
                </button>
              </div>

              <!-- Sign up link -->
              <div class="text-center mt-4 pt-2 border-top">
                <small class="text-muted">
                  Need an account?
                  <a routerLink="/register" class="fw-bold text-primary text-decoration-none ms-1"
                    >Register Practice/As Doctor</a
                  >
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
}
